<template>
    <div class="page-lost">
        <div class="page-lost_box bg-white rounded-10 shadow">
            <h1>{{ $t('pageNotFound.title') }}</h1>
            <p>
                {{ $t('pageNotFound.message') }}
            </p>

            <router-link class="medium-button blue-gradient" :to="{ name: 'Home' }">{{ $t('pageNotFound.buttonText') }}</router-link>

        </div>
    </div>

</template>

<script>
    // @ is an alias to /src


    export default {
        name: 'NotFound',
        components: {

        }
    }
</script>
